import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlane = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.8542 8.125C16.872 8.125 18.6429 8.97461 18.6429 10C18.6429 11.0547 16.872 11.875 15.8542 11.875H12.3839L9.39286 17.0283C9.22321 17.3213 8.90774 17.5 8.56548 17.5H6.89286C6.57738 17.5 6.34821 17.2012 6.43452 16.9023L7.89286 11.875H4.83333L3.54762 13.5625C3.45833 13.6797 3.31548 13.75 3.16667 13.75H1.91667C1.68452 13.75 1.5 13.5654 1.5 13.3398C1.5 13.3018 1.50595 13.2637 1.51488 13.2256L2.45238 10L1.51488 6.77441C1.50298 6.73633 1.5 6.69824 1.5 6.66016C1.5 6.43164 1.6875 6.25 1.91667 6.25H3.16667C3.31548 6.25 3.45833 6.32031 3.54762 6.4375L4.83333 8.125H7.89583L6.4375 3.09766C6.34821 2.79883 6.57738 2.5 6.89286 2.5H8.56548C8.90774 2.5 9.22321 2.68164 9.39286 2.97168L12.3839 8.125H15.8542Z",
		fill: "#0D2976"
	})
});
export default SvgPlane;
